import { Strings as ChingariStrings } from "./chingari.io";
import { Strings as AstroStrings } from "./astrolive.app";

export const getDomainStrings = () => {
  if (typeof window !== "undefined") {
    if (window?.location?.hostname?.includes("astrolive")) {
      return AstroStrings;
    }
  }

  return ChingariStrings;
};

export const getStringsFromDomain = (hostname: string) => {
  if (hostname?.includes("astrolive")) return AstroStrings;
  return ChingariStrings;
};
